'use client';

import React, { useRef } from 'react';
import classes from '@/components/shop/shop-home.module.scss';
import { useDispatch } from 'react-redux';
import { setShopSearchKeyword } from '@/slice/shopSlice';

function ShopSearch({
  dict: { placeholderShop },
}: {
  dict: { placeholderShop: string };
}) {
  const dispatch = useDispatch();
  const searchKeywordRef = useRef<HTMLInputElement>(null);

  const handleSearch = () => {
    if (searchKeywordRef.current) {
      dispatch(setShopSearchKeyword(searchKeywordRef.current.value));
    }
  };

  return (
    <div className={classes.searchInputBox}>
      <input type="text" placeholder={placeholderShop} ref={searchKeywordRef} />
      <button
        type="button"
        className={classes.searchBtn}
        onClick={handleSearch}
      ></button>
    </div>
  );
}

export default ShopSearch;
